import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ModalPop from '../modal/modal';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const TagOrderCsvUpload = ({
  handleModalHide,
  handlebulkSubmit,
  handleFileChange,
  selectedFile,
  isUploaded,
  redirectUrl,
  showBulkCsv,
  isSubmitting,
  errorMessage,
  selectedOrderId,
}) => {
  const { baseUrl } = useContext(BaseUrl);

  return (
    <ModalPop
      title={localization.uploadCSV}
      show={showBulkCsv}
      handleModalHide={handleModalHide}
      keyboard
      backdrop
      footer={!isUploaded}
      footerSubmitTxt={isSubmitting ? 'Uploading…' : localization.submit}
      handleModalSubmit={handlebulkSubmit}
      disableSubmit={!selectedFile || isSubmitting}
    >
      <div className="bulk_upload text-center">

        {errorMessage && (
          <p className="text-danger mb-3">{errorMessage}</p>
        )}

        {isUploaded ? (
          <>
            <div className="success">
              <img src={Images?.tick} alt="success" />
            </div>

            <p>{localization.uploadSuccess}</p>

            <Link
              to={`${baseUrl}${redirectUrl}`}
              className="btn btn-primary mb-4"
              onClick={handleModalHide}
            >
              {localization.viewTagOrders}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </>
        ) : (
          <div style={{ margin: '4px' }}>
            <label className="btn btn-secondary w-auto mt-2">
              Choose CSV File
              <input
                type="file"
                accept=".csv"
                style={{ display: 'none' }}
                onChange={(e) => handleFileChange(e.target.files[0])}
              />
            </label>

            {selectedFile && (
              <p className="mt-2">
                Selected File: <b>{selectedFile.name}</b>
              </p>
            )}
          </div>
        )}
      </div>
    </ModalPop>
  );
};

TagOrderCsvUpload.propTypes = {
  handleModalHide: PropTypes.func.isRequired,
  handlebulkSubmit: PropTypes.func.isRequired,
  handleFileChange: PropTypes.func.isRequired,
  selectedFile: PropTypes.object,
  isUploaded: PropTypes.bool,
  redirectUrl: PropTypes.string,
  showBulkCsv: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default TagOrderCsvUpload;
